import type { GetPMNodeHeight } from '@atlaskit/editor-common/extensibility';
import type { ExtensionHandlers } from '@atlaskit/editor-common/extensions';
import type { ExtensionPluginOptions } from '@atlaskit/editor-plugin-extension';

interface Props {
	options: {
		__rendererExtensionOptions?: ExtensionPluginOptions['__rendererExtensionOptions'];
		appearance?: ExtensionPluginOptions['appearance'];
		extensionHandlers?: ExtensionHandlers;
		getExtensionHeight?: GetPMNodeHeight;
		/**
		 * On a locked template the element floating toolbar keeps only the breakout
		 * options and the edit button — copying or deleting an element would be
		 * refused by hubTemplateLockPlugin, so the buttons are not offered.
		 */
		isTemplateLocked?: boolean;
	};
}

export function extensionPluginOptions({ options }: Props): ExtensionPluginOptions {
	const isTemplateLocked = Boolean(options.isTemplateLocked);

	return {
		breakoutEnabled: true,
		copyEnabled: !isTemplateLocked,
		deleteEnabled: !isTemplateLocked,
		extensionHandlers: options.extensionHandlers,
		useLongPressSelection: false,
		appearance: options.appearance ?? 'full-page',
		__rendererExtensionOptions: options.__rendererExtensionOptions,
		getExtensionHeight: options.getExtensionHeight,
	};
}
